import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField, useTheme } from "@mui/material";
import { isEmpty } from "lodash";
import { useState } from "react";
import { ApiResponseType } from "../../types";
import { client } from "../../utils/axios-client";

type Props = {
    roleId: string,
    open: boolean,
    onCancel: () => void,
    onSaved: () => void
}

const CreateRoleDialog = ({ open, onCancel, roleId, onSaved }: Props) => {
    const [roleName, setRoleName] = useState('');
    const [error, setError] = useState(false);
    const [saveError, setSaveError] = useState(false);
    const [duplicateRoleNameError, setDuplicateRoleNameError] = useState(false);
    const theme = useTheme();

    const onConfirm = async () => {
        setError(false);
        setDuplicateRoleNameError(false);
        setSaveError(false);

        if (isEmpty(roleName)) {
            setError(true);
            return;
        }

        const availableNameResponse = await client.get<ApiResponseType>('/api/admin/roles/name/available', { params: { name: roleName } });

        if (!availableNameResponse.data.succeeded) {
            setDuplicateRoleNameError(true);
            return;
        }

        const saveResponse = await client.post<ApiResponseType>('/api/admin/roles', { id: roleId, name: roleName, isAdmin: false, modules: [] });

        if (!saveResponse.data.succeeded) {
            setSaveError(true);
        } else {
            onSaved();
        }
    }

    return (
        <Dialog
            open={open}
            onClose={onCancel}
        >
            <DialogTitle>
                Add Role
            </DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', margin: 5 }}>
                    <TextField label="Role Name" value={roleName} onChange={e => setRoleName(e.target.value)} />
                    {error && <Box sx={{ color: theme.palette.error.main }}>Please enter a valid role name. </Box>}
                    {error && <Box sx={{ color: theme.palette.error.main }}>Error saving role.</Box>}
                    {duplicateRoleNameError && <Box sx={{ color: theme.palette.error.main }}>A role with name {roleName} already exists.</Box>}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel}>Cancel</Button>
                <Button onClick={onConfirm} autoFocus>
                    Add Role
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default CreateRoleDialog;